import { ProfileType, Target } from '~/types/profile';
import { ObjectType } from '~/types';
import { IdentityType } from '~/types/TransactionsHistory';

export const getProfileTypeByResource = (resource: string): ProfileType | undefined => {
  switch (resource) {
    case 'businesses':
      return 'BUSINESS';
    case 'individuals':
      return 'INDIVIDUAL';
    case 'partners':
      return 'PARTNER';
    case 'tenant':
    case 'tenant/accounts':
      return 'TENANT';
    default:
      return undefined;
  }
};

export const getResourceByProfileType = (
  profileType: ProfileType
): 'businesses' | 'individuals' | 'partners' | 'tenant/accounts' | undefined => {
  switch (profileType) {
    case 'INDIVIDUAL':
      return 'individuals';
    case 'BUSINESS':
      return 'businesses';
    case 'PARTNER':
      return 'partners';
    case 'TENANT':
      return 'tenant/accounts';
    default:
      return undefined;
  }
};

export const getObjectTypeByResource = (resource: string): ObjectType | undefined => {
  switch (resource) {
    case 'individuals':
      return 'INDIVIDUAL';
    case 'businesses':
      return 'BUSINESS';
    case 'partners':
      return 'PARTNER';
    case 'pricings':
      return 'PRICING';
    case 'accounts':
    case 'tenant/accounts':
      return 'ACCOUNT';
    case 'employees':
      return 'EMPLOYEE';
    case 'team':
      return 'DASHBOARD_IDENTITY';
    case 'apiIdentities':
      return 'API_IDENTITY';
    case 'solutions':
      return 'SOLUTION';
    case 'deals':
      return 'DEAL';
    case 'headTransactions':
      return 'HEAD_TRANSACTION';
    case 'actionReports':
      return 'ACTION_REPORT';
    case 'roles':
      return 'DASHBOARD_ROLE';
    case 'externalProfileLinks':
      return 'EXTERNAL_PROFILE_LINK';
    case 'events':
      return 'EVENT';
    default:
      return undefined;
  }
};

export const mapIdentityTypeToObjectType = (identityType?: IdentityType): ObjectType | null => {
  if (!identityType) return null;
  switch (identityType) {
    case 'API':
      return 'API_IDENTITY';
    case 'DASHBOARD':
      return 'DASHBOARD_IDENTITY';
    case 'INTEGRATION':
      return 'INTEGRATION_IDENTITY';
    default:
      return null;
  }
};

export const getAccountResourceByProfileType = (profileType: ProfileType): Target | undefined => {
  switch (profileType) {
    case 'INDIVIDUAL':
      return 'individuals';
    case 'BUSINESS':
      return 'businesses';
    case 'PARTNER':
      return 'partners';
    case 'TENANT':
      return 'tenant';
    default:
      return undefined;
  }
};
